$(function () {
	if (window.location.hash === '#tab-orders') {
		$('#tab-orders-btn').trigger('click');
	}

	var $billing = $('#profileBillingForm');
	function updateBillingType() {
		var company = $billing.find('[name="invoice_type"]').val() === 'company';
		$billing.find('[name="invoice_vat"]').prop('required', company).closest('.col-12').toggle(company);
	}
	$billing.find('[name="invoice_type"]').on('change', updateBillingType);
	updateBillingType();

	$billing.on('submit', function (event) {
		event.preventDefault();
		var $button = $billing.find('[type="submit"]').prop('disabled', true);
		$.ajax({
			url: $billing.attr('action'),
			method: 'POST',
			data: $billing.serialize(),
			success: function (response) {
				GlobalSwal.fire({ icon: 'success', text: response.message });
			},
			error: function (xhr) {
				var response = xhr.responseJSON || {};
				var message = response.errors ? Object.values(response.errors).flat().join('\n') : response.message;
				GlobalSwal.fire({ icon: 'error', text: message || window.Lang.prof_save_error });
			},
			complete: function () { $button.prop('disabled', false); }
		});
	});

	$('.profile-reorder').on('click', function () {
		var $button = $(this).prop('disabled', true);
		function showResult(response, success) {
			GlobalSwal.fire({
				icon: response.warnings && response.warnings.length ? 'warning' : (success ? 'success' : 'error'),
				text: [response.message || window.Lang.prof_save_error].concat(response.warnings || []).join('\n'),
				showCancelButton: success,
				confirmButtonText: success ? window.Lang.cart_go_checkout : window.Lang.confirm_button,
				cancelButtonText: window.Lang.cart_continue_shopping
			}).then(function (result) {
				if (success && result.isConfirmed) window.location.assign('/checkout');
			});
		}
		$.ajax({
			url: $button.data('url'),
			method: 'POST',
			data: { _token: $('meta[name="csrf-token"]').attr('content') },
			success: function (response) {
				if (typeof window.loadCart === 'function') window.loadCart();
				showResult(response, true);
			},
			error: function (xhr) { showResult(xhr.responseJSON || {}, false); },
			complete: function () { $button.prop('disabled', false); }
		});
	});
});
